import React, { useState } from "react";
import PropTypes from "prop-types";
import { TextField, makeStyles } from "@material-ui/core";
import axios from "axios";
import { isNumber, isSpecial, url } from "../../lib/Common";
const useStyles = makeStyles({
  TextField: {
    marginTop: 10,
    marginBottom: 10,
  },
  TextLabel: {
    fontWeight: "bold",
    color: "black",
  },
});

function Name({ nameRef, name, onChangeName }) {
  const classes = useStyles();
  const [errorText, setErrorText] = useState("");
  const [errorValue, setErrorValue] = useState(false);

  const handleNameValidate = (value) => {
    if (isNumber.test(value) || isSpecial.test(value)) {
      setErrorText("한글 / 영문만 입력 가능합니다.");
      setErrorValue(true);
      nameRef.current.focus();
    } else if (value.length <= 1) {
      setErrorText("2글자 이상 데이터 입력하세요.");
      setErrorValue(true);
      nameRef.current.focus();
    } else {
      validateName(value);
    }
  };

  const validateName = async (inputName) => {
    const urlCheck = url + "/api/specialMember/SpecialNameCheck";
    try {
      const response = await axios.post(
        urlCheck,
        { name: inputName },
        { withCredentials: true }
      );
      if (response.data.COUNT === "0") {
        setErrorText("해당 이름은 존재하지 않습니다.");
        setErrorValue(true);
      } else {
        setErrorText("");
        setErrorValue(false);
        onChangeName(inputName);
      }
    } catch (e) {
      setErrorText("서버 호출 에러");
      setErrorValue(true);
    }
    return;
  };
  return (
    <TextField
      className={classes.TextField}
      autoFocus
      required
      fullWidth
      inputRef={nameRef}
      error={errorValue}
      helperText={errorText}
      label="이름(Name)"
      type="text"
      variant="filled"
      onBlur={(e) => {
        handleNameValidate(e.target.value);
      }}
      InputLabelProps={{
        className: classes.TextLabel,
      }}
      FormHelperTextProps={{ className: classes.TextLabel }}
      name="name"
      defaultValue={name}
    />
  );
}

Name.propTypes = {
  nameRef: PropTypes.object,
  name: PropTypes.string,
  onChangeName: PropTypes.func,
};

export default Name;
